import {
  TIcon,
  CompletedIcon,
  InProgressIcon,
  StateCircleIcon,
  CancelledIcon,
} from '@acceso/design-system';

import { I18nextTranslationKeys } from '@/i18n/i18next';
import { FileUploadState } from '@/types';

type FileUploadStateIconData = {
  icon: TIcon;
  label: I18nextTranslationKeys;
};

export const FILE_UPLOAD_STATE_TO_ICON_DATA: Record<FileUploadState, FileUploadStateIconData> = {
  [FileUploadState.FINISHED]: {
    icon: props => <CompletedIcon {...props} className="text-feedback-success-20" />,
    label: 'Terminado',
  },
  [FileUploadState.IN_PROGRESS]: {
    icon: props => <InProgressIcon {...props} className="text-feedback-info-20" />,
    label: 'En proceso',
  },
  [FileUploadState.PENDING]: {
    icon: props => <StateCircleIcon {...props} className="text-accent-active-primary-40" />,
    label: 'Pendiente',
  },
  [FileUploadState.ERROR]: {
    icon: props => <CancelledIcon {...props} className="text-feedback-error-20" />,
    label: 'Error',
  },
};
